import { forwardRef } from 'react';

import {
  Typography as Text,
  TypographyProps as TextProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

export interface ExpressionOperatorProps
  extends Omit<TextProps, 'classes'>,
    WithStyles<typeof styles> {}

const ExpressionOperator = forwardRef<HTMLDivElement, ExpressionOperatorProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Text
        ref={ref}
        color="textSecondary"
        className={classNames(className, classes?.root)}
        {...rest}
      />
    );
  },
);

ExpressionOperator.displayName = 'Expression.Operator';

export default withStyles(styles)(ExpressionOperator);
